import { Injectable, inject } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { Observable, of } from "rxjs";
import { map, take, switchMap, filter } from "rxjs/operators";
import { AuthService } from "../services/auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.authService.authInitialized$.pipe(
      filter((initialized) => initialized),
      take(1),
      switchMap(() => this.authService.currentSession$),
      take(1),
      map((session) => {
        if (session) {
          return true;
        }

        this.authService.setRedirectPath(state.url);
        this.authService.openLoginModal();
        this.router.navigate(["/"]);
        return false;
      })
    );
  }
}
